export const orgAdminAreaData = {
    sideNavCatagoryData: [
        {
            name: 'OrgTeam',
            link: 'org-admin/OrgTeam'
        },
        {
            name: 'Team Member - Upload',
            link: 'org-admin/TeamMemberUpload'
        },
        {
            name: 'Member Levels',
            link: 'org-admin/MemberLevel'
        },
        {
            name: 'Org Team Members',
            link: 'org-admin/OrgTeamMembers'
        },
        {
            name: 'PA Users',
            link: 'org-admin/PaUsers'
        },
        {
            name: 'PA Users Permissions',
            link: `org-admin/PaUsersPermissions`
        },
        {
            name: 'Module Permissions',
            link: `org-admin/ModulePermissions`
        }
    ]
}

export const superAdminAreaData = {
    sideNavCatagoryData: [{
        name: 'Org Details',
        link: 'super-admin/org-details'
    }, {
        name: 'Add Organisation',
        link: 'super-admin/add-organisation',
    }, {
        name: 'Manage Batch',
        link: 'super-admin/manage-batch',
    }, {
        name: 'Manage Org Admins',
        link: 'super-admin/manage-org-admins',
    }, {
        name: 'Manage Credits',
        link: 'super-admin/manage-credits',
    },
    //  {
    //     name: 'Update Latest Assessment',
    //     link: 'super-admin/update-latest-assessment',
    // },
    {
        name: 'Define Metrics',
        link: 'super-admin/metric',
    },
    {
        name: 'Assign Metrics to this Org',
        link: 'super-admin/assign-metrics',
    },{
        name: 'Assign Relations to this Org',
        link: 'super-admin/assign-assessors'
    }, {
        name: 'SWOT Text',
        link: 'super-admin/analyse-text-swot',
    }, {
        name: 'Focus Areas Text',
        link: 'super-admin/analyse-text-focus-areas',
    }, {
        name: 'Review Questions- Context',
        link: 'super-admin/orientation-text-review-questions-context',
    }, {
        name: 'Review Questions- Threat',
        link: 'super-admin/analyse-text-review-threat',
    }, {
        name: 'Review Questions- Weakness',
        link: 'super-admin/analyse-text-review-weakness',
    }]
}

export const AnalyzeData = {
    sidebarFilterData: [
        {
            relationName: 'Bosses'
        },
        {
            relationName: 'Customers'
        },
        {
            relationName: 'Direct Reports'
        },
        {
            relationName: 'Peers'
        }
    ],
    flterTeamData: {
        teamLead: 'Anandam',
        teamMembers: [
            {
                name: "Magret Madalina",
            },
            {
                name: "Ashok Kumar Gms",
            },
            {
                name: "Prathap",
            },
            {
                name: "Shaik Ismail Moinuddin Chesty",
            },
            {
                name: "Sreedhar Adupa",
            },
        ]
    }
}

export const VirtualTeamSidebarNav = {
    sideNavCatagoryData: [
        {
            name: 'OrgTeam',
            link: 'my-teams/manage-virtual-teams'
        },
        {
            name: 'OrgTeam',
            link: 'my-teams/virtual-teams/manage-members'
        },
        {
            name: 'OrgTeam',
            link: 'my-teams/virtual-teams/manage-share'
        },
    ]
}



// WEBPACK FOOTER //
// ./src/_pages/Organzation/OrgAdminArea/SidebarData.js